export const BREAKS = {
  inningsbreak: 'inningsbreak',
  drinks: 'drinksbreak',
  tea: 'teabreak',
  lunch: 'lunchbreak',
  dinner: 'dinnerbreak'
}



// WEBPACK FOOTER //
// ../app/constants/kveventsBreaks.js